(function () {
  var d = document.currentScript.dataset;
  var lp = d.prev || 'Geri';
  var ln = d.next || 'Ileri';
  var MQ = matchMedia('(min-width: 990px)');
  var C = 'mqle-rnav__btn';

  function mk(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = C + ' ' + C + '--' + dir;
    b.setAttribute('aria-label', label);
    return b;
  }

  function setup(rail) {
    if (rail.dataset.rn || rail.scrollWidth - rail.clientWidth < 8) return;
    if (rail.parentElement.querySelector('[data-mqle-rail-prev]')) return;
    rail.dataset.rn = '1';
    var box = rail.parentElement;
    box.classList.add('mqle-rnav');
    var prev = mk('prev', lp);
    var next = mk('next', ln);
    box.append(prev, next);

    function go(sign) {
      return function () {
        var a = rail.children[0];
        var b = rail.children[1];
        var w = b ? b.offsetLeft - a.offsetLeft : a.offsetWidth;
        rail.scrollBy({ left: sign * w, behavior: 'smooth' });
      };
    }
    rail.u = function () {
      prev.hidden = rail.scrollLeft < 8;
      next.hidden = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
      prev.style.top = next.style.top = rail.offsetTop + rail.offsetHeight / 2 + 'px';
    };
    prev.addEventListener('click', go(-1));
    next.addEventListener('click', go(1));
    rail.addEventListener('scroll', rail.u, { passive: true });
    rail.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        rail.scrollBy({ left: e.deltaY });
      }
    });
    rail.u();
  }

  function scan() {
    if (!MQ.matches) return;
    document.querySelectorAll('[data-mqle-rail]').forEach(function (r) {
      setup(r);
      if (r.u) r.u();
    });
  }

  if (!window.mqleRN) {
    window.mqleRN = 1;
    addEventListener('resize', scan);
    MQ.addEventListener('change', scan);
    document.addEventListener('shopify:section:load', scan);
  }
  scan();
})();
